import {
  STATUS_SEARCH
} from '../constants/Found'

export default function found (state = '', action) {
  if (action.type === STATUS_SEARCH) {
    return action.payload
  }
  return state;
}